import cx from 'classnames';

interface Props {
  theme: 'light' | 'dark' | 'secondary';
  text: string;
  icon: React.ReactNode;
}

const PostBadge = ({ theme, text, icon }: Props) => {
  return (
    <div className="relative mb-1 mt-1 inline-flex items-center space-x-1 overflow-hidden rounded-wt px-2 py-1 text-xs">
      <div
        className={cx(
          'absolute inset-0',
          theme === 'light' ? 'bg-wt-primary text-wt-primary opacity-10' : '',
          theme === 'dark' ? 'bg-wt-primary text-wt-text-on-primary' : '',
        )}
      />
      {icon}
      <span className="z-10">{text}</span>
    </div>
  );
};

export default PostBadge;
